export default "__VITE_ASSET__C3F7QibT__"